export default __webpack_public_path__ + "files/favicon-ce0f7dbd83d65d585c843ab98ee79df4.png";